import * as React from 'react';
import * as wq from '@packages/systems/wfdl-Qualified';
import * as w from '@packages/systems/wfdl';
import * as wast from '@packages/systems/wfdl-ast';

import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';

const HeadersType = w.withSystem(
  {isFullWidth: true},
  wast.TList(
    wast.TTypeConstructor(
      wq.qualify(w.Plugins.name('Http'), wq.typeName('Name & Value'))
    )
  )
);

export const RequestHeadersType = w.TypeImplementation.Alias({
  type: HeadersType,
  render: function RenderHeaders({expr, dispatch}) {
    return <ExpressionEditor dispatch={dispatch} expression={expr} />;
  },
});
